<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入商品名称进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search"
                              clearable
							  size="medium"
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                    <!-- <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button> -->
                </div>
                <div>
					<!-- <el-button type="success" @click="exportData" icon="el-icon-download">
						导出数据
					</el-button> -->
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加订单
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                <!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->
                <el-table-column
                        prop="koId"
                        align="center"
                        label="订单编码"
                        width="220">
                </el-table-column>
				<el-table-column
				        prop="koCustomerTel"
				        align="center"
				        label="所属客户"
				        width="160">
				</el-table-column>
                <el-table-column
                        prop="koCommodityName"
                        label="商品名称"
                        align="center"
                        width="280">
                </el-table-column>
                <el-table-column
                        prop="koCommodityCount"
                        width="160"
                        align="center"
                        label="购买数量">
                </el-table-column>
				<el-table-column
				        prop="koOrderAmt"
				        width="160"
				        align="center"
				        label="订单金额(元)">
				</el-table-column>
                <el-table-column
                        prop="koAddUserName"
                        width="100"
                        align="center"
                        label="创建人">
                </el-table-column>
				<el-table-column
				        prop="koCreateTime"
				        width="160"
				        align="center"
				        label="创建时间">
				</el-table-column>
				<el-table-column
				        prop="koUpdateUserName"
				        width="100"
						align="center"
				        label="最新修改人">
				</el-table-column>
                <el-table-column
                        prop="koUpdateTime"
                        width="160"
						align="center"
                        label="最新修改时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        width="180"
						align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
				v-loading="loading2"
				element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"
                width="80%">
            <div class="dialog-box">
                <el-form :model="kytOrder" :rules="rules" ref="empForm">
					<el-row>
						<el-form-item label="订单客户:" prop="koCustomerTel">
							<div class="input_box">
								<el-select v-model="kytOrder.koCustomerTel" placeholder="请选择客户" size="medium"
								           style="margin-left: 5px;margin-right: 5px">
								    <el-option
								            v-for="item in customerList"
								            :key="item.cusTelNum"
								            :label="item.cusTelNum"
								            :value="item.cusTelNum">
								    </el-option>
								</el-select>
							</div>
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="购买商品:" prop="koCommodityid">
							<div class="input_box">
								<el-select v-model="kytOrder.koCommodityid" placeholder="请选择商品" size="medium"
								           style="margin-left: 5px;margin-right: 5px">
								    <el-option
								            v-for="item in commoditysList"
								            :key="item.kcId"
								            :label="item.kcName"
								            :value="item.kcId">
								    </el-option>
								</el-select>
							</div>
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="购买商品数量:" prop="koCommodityCount">
							<div class="input_box">
								<el-input size="medium" prefix-icon="el-icon-edit" v-model="kytOrder.koCommodityCount" maxlength="10" show-word-limit
										  placeholder="请输入购买商品数量"></el-input>
							</div>
						</el-form-item>
					</el-row>
                    <el-row>
						<el-form-item label="订单金额:" prop="koOrderAmt">
							<div class="input_box">
								<el-input size="medium" prefix-icon="el-icon-edit" v-model="kytOrder.koOrderAmt" maxlength="10" show-word-limit
										  placeholder="请输入订单金额"></el-input>
							</div>
						</el-form-item>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doAddEmp">确 定</el-button>
			  </span>
        </el-dialog>
    </div>
</template>

<script>
	import { v4 as uuidv4 } from 'uuid'
    export default {
        name: "Tenants",
        data() {
            return {
                title: '',
				showAdvanceSearchView: false,
                allDeps: [],
                emps: [],
				commoditysList:[],
				customerList:[],
                loading: false,
				loading2: false,
                dialogVisible: false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
				optionIndex:[
					'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'
				],
                kytOrder: {
					koCustomerTel:'',
					koCommodityid:'',
					koCommodityCount:'',
					koOrderAmt:''
                },
                rules: {
					koCustomerTel:[{required: true, message: '请选择客户', trigger: 'blur'}],
                    koCommodityid: [{required: true, message: '请选择商品', trigger: 'blur'}],
					koCommodityCount: [{required: true, message: '请输入购买数量', trigger: 'blur'}],
					koOrderAmt: [{required: true, message: '请输入订单金额', trigger: 'blur'}]
                }
            }
        },
        mounted() {
            this.initEmps();
            this.initData();
        },
        methods: {
            emptyEmp() {
                this.kytOrder = {
					koCustomerTel:'',
					koCommodityid:'',
					koCommodityCount:'',
					koOrderAmt:''
                }
            },
            showEditEmpView(data) {
                this.title = '编辑订单信息';
                this.emp = data;
                this.dialogVisible = true;
				this.queryFormulaInfo(data);
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/order/basic/del/" + data.koId).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
			queryFormulaInfo(data){
				this.loading2 = true;
				let url = '/order/basic/getOrderInfoById/'+data.koId;
				this.getRequest(url).then(resp => {
                    this.loading2 = false;
                    if (resp.status == 200) {
						this.kytOrder.koId = resp.obj.koId;
						this.kytOrder.koCustomerTel = resp.obj.koCustomerTel;
						this.kytOrder.koCommodityid = resp.obj.koCommodityid;
						this.kytOrder.koCommodityCount = resp.obj.koCommodityCount;
						this.kytOrder.koOrderAmt = resp.obj.koOrderAmt;
                    }else{
						this.$message({
						    type: 'info',
						    message: '查询信息有误'
						});
					}
                });
			},
            doAddEmp() {
                if (this.kytOrder.koId) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/order/basic/update", this.kytOrder).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/order/basic/add", this.kytOrder).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initData() {
				this.getAllCommoditysList()
				this.getAllCustomerList()
            },
			getAllCommoditysList(){
				this.commoditysList = []
				this.getRequest('/commodity/basic/getAllCommoditysList').then(resp => {
				    if (resp.status == 200) {
				        this.commoditysList = resp.obj
				    }
				});
			},
			getAllCustomerList(){
				this.customerList = []
				this.getRequest('/customer/basic/getAllCustomerList').then(resp => {
				    if (resp.status == 200) {
				        this.customerList = resp.obj
				    }
				});
			},
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加订单';
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                let url = '/order/basic/getOrdersList?page=' + this.page + '&size=' + this.size;
                url += "&koCommodityName=" + this.keyword;
				
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
	.el-form-item {
		display: flex;
		.input_box {
			width: 28.5rem;
			.el-input {
				width: 100% !important;
			}
		}
	}
	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;
		.box_tit {
			font-size: 0.875rem;
		}
	}
	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}
	.options_warp {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		.option_item {
			margin-bottom: 0.625rem;
		}
	}
	::v-deep .dialog-box {
		.el-form-item__label {
			width: 8.625rem;
		}
	}

</style>
